// extracted by mini-css-extract-plugin
export default {"mCard":"bD-z","image":"cD-z","imageNoBackground":"dD-z","imageHasCategory":"eD-z","fullWidth":"fD-z"};